import { render, staticRenderFns } from "./Campo.vue?vue&type=template&id=0673ded4&scoped=true&"
import script from "./Campo.vue?vue&type=script&lang=js&"
export * from "./Campo.vue?vue&type=script&lang=js&"
import style0 from "./Campo.vue?vue&type=style&index=0&id=0673ded4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673ded4",
  null
  
)

export default component.exports